import { snapdocsSubscriptionsApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { SnapdocsSubscriptionsLoadState } from 'constants/snapdocsSubscriptions';
import { catchAsyncActionError } from 'utils/action';
import { getDefaultErrorMessage } from 'utils/axios';
import { createNamedActions } from 'utils/namedActionTypesProxy';
import { getUUID } from 'utils/uuid';

export const SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE = createNamedActions('snapdocsSubscriptions', {
  GET_SNAPDOCS_SUBSCRIPTIONS_REQUEST: 'GET_SNAPDOCS_SUBSCRIPTIONS_REQUEST',
  GET_SNAPDOCS_SUBSCRIPTIONS_SUCCESS: 'GET_SNAPDOCS_SUBSCRIPTIONS_SUCCESS',
  GET_SNAPDOCS_SUBSCRIPTIONS_FAILURE: 'GET_SNAPDOCS_SUBSCRIPTIONS_FAILURE',
  REGISTER_SNAPDOCS_SUBSCRIPTION_REQUEST: 'REGISTER_SNAPDOCS_SUBSCRIPTION_REQUEST',
  REGISTER_SNAPDOCS_SUBSCRIPTION_SUCCESS: 'REGISTER_SNAPDOCS_SUBSCRIPTION_SUCCESS',
  REGISTER_SNAPDOCS_SUBSCRIPTION_FAILURE: 'REGISTER_SNAPDOCS_SUBSCRIPTION_FAILURE',
});

const LIST_FAILURE_LOAD_STATE = {
  [HTTP_RESPONSE_STATUS_CODES.UNPROCESSABLE_ENTITY]: SnapdocsSubscriptionsLoadState.NOT_CONFIGURED,
  [HTTP_RESPONSE_STATUS_CODES.FORBIDDEN]: SnapdocsSubscriptionsLoadState.UNAVAILABLE,
};

export const getSnapdocsSubscriptionsAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      const requestId = getUUID();

      dispatch({
        type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_REQUEST,
        payload: { requestId },
      });

      try {
        const { data } = await snapdocsSubscriptionsApi.getSubscriptions({ companyId });

        dispatch({
          type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_SUCCESS,
          payload: { requestId, subscriptions: data ?? [] },
        });
      } catch (error) {
        dispatch({
          type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_FAILURE,
          payload: {
            requestId,
            loadState:
              LIST_FAILURE_LOAD_STATE[error?.response?.status] ??
              SnapdocsSubscriptionsLoadState.ERROR,
            errorMessage: getDefaultErrorMessage(error),
          },
        });
      }
    },
);

export const registerSnapdocsSubscriptionAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      dispatch({ type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_REQUEST });

      try {
        const { data } = await snapdocsSubscriptionsApi.registerSubscription({ companyId });

        dispatch({
          type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_SUCCESS,
        });
        await dispatch(getSnapdocsSubscriptionsAction({ companyId }));

        return data;
      } catch (error) {
        dispatch({
          type: SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_FAILURE,
        });
        throw error;
      }
    },
);
